import { render, staticRenderFns } from "./MyWalletProceedButton.vue?vue&type=template&id=181d0244&scoped=true"
import script from "./MyWalletProceedButton.vue?vue&type=script&lang=ts"
export * from "./MyWalletProceedButton.vue?vue&type=script&lang=ts"
import style0 from "./MyWalletProceedButton.vue?vue&type=style&index=0&id=181d0244&prod&lang=scss&scoped=true"
import style1 from "./MyWalletProceedButton.vue?vue&type=style&index=1&id=181d0244&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181d0244",
  null
  
)

export default component.exports